// extracted by mini-css-extract-plugin
export default {"dialog":"ModulesContainer_dialog__i02Gf","settings":"ModulesContainer_settings__-Merk"};